'use strict';

import { REVIEWS_EXCEPTIONS } from '../../constants/reviews';

export default class ListUtil {


    constructor(_paramQuery, config, separator) {
        this.paramQuery = _paramQuery;
        this.config = config;
        this.place = window.__pt.place || {};
        this.separator = separator;
        this.cultureData = window.__pt.cultureData || {};

    }

    getExternalAvailability() {
        let valid = true;
        let externalAvailability = this.paramQuery.getexternalavailability || null;
        if (externalAvailability != null) {
            valid = externalAvailability;
        } else {
            if (this.place && this.place.locationInfo && this.config.externalAvailability) {
                valid = this.config.externalAvailability.indexOf(this.place.locationInfo.countryA2) == -1;
                if (valid) {
                    valid = this.config.externalAvailability.indexOf(this.place.locationInfo.countryISO) == -1;
                }
            }
        }
        return valid;
    }
  
    groupItems(items, size) {
        let grouped = [];
        let index = 0;
        let currentSize = size;

        for (var i = 0; i < items.length; i++) {
            if (window.angular.isUndefined(grouped[index])) {
                grouped[index] = [];
            }

            grouped[index].push(items[i]);

            if ((i + 1) % currentSize === 0) {
                if (currentSize == size) {
                    currentSize = currentSize * this.config.listItemsCount;
                    index++;
                }
            }

        }

        return grouped;
    }

    buildPaginator(totalHotels, hotelLength, currentPage) {
        const pointBreak = 4;
        let pagination = {
            currentPage :currentPage
        };

        pagination.totalPages = Math.ceil(totalHotels/ this.config.listItemsCount);
        pagination.buttons = Array.from({ length: pagination.totalPages }, (_, i) => i + 1);
        pagination.startPage = 1 + (pagination.currentPage * 18);
        pagination.endPage = (pagination.startPage + (hotelLength)) - 1;
        if (pagination.endPage > pagination.totalHotels) {
            pagination.endPage = pagination.totalHotels;
        }

        if (pagination.totalPages <= pointBreak) {
            pagination.render = pagination.buttons;
            return pagination;
        }

        pagination.render = [];
        if (pagination.currentPage < pointBreak - 1) {
            pagination.render = pagination.buttons.slice(0, pointBreak);
            pagination.render.push(this.separator);
            pagination.render.push(pagination.totalPages);
        } else if (pagination.currentPage > pagination.totalPages - pointBreak) {
            pagination.render.push(pagination.buttons[0]);
            pagination.render.push(this.separator);
            pagination.render.push(...pagination.buttons.slice(pagination.totalPages - pointBreak, pagination.totalPages));
        } else {
            pagination.render.push(pagination.buttons[0]);
            pagination.render.push(this.separator);
            pagination.render.push(...pagination.buttons.slice(pagination.currentPage - 1, pagination.currentPage + 2));
            pagination.render.push(this.separator);
            pagination.render.push(pagination.totalPages);
        }

        //$location.search('page', pagination.currentPage + 1);

        return pagination;
    }


    ptUsaProvisionalOrder(filters) {
        const index = filters.findIndex(filter => filter.display === 'without category');
        if (index > -1) {
            const temp = filters[index];
            temp.display = 'Unrated';
            filters.splice(index, 1);
            filters.push(temp);

            return filters;
        }
        return filters;
    }

    getUrlToDetail(item, query) {
        const isHotel = item.productType == 1 || item.productType == 0;
        const path = isHotel ? this.config.pathHotelDetail : this.config.pathAccommodationDetail;
        const uri = isHotel ? item.uri : "property";
        return `${this.config.siteUrl}${path}${uri}_a${item.productId}?${query}`;
    }

    getHotelOrAccomodationsIds(list = [], type = 1) {
        return list.filter(item => item.productType === type).map(item => item.productId);
    }


    setIsSelectCustomFilter(filtersResponse) {
        let newFilters = [];
        if (filtersResponse) {
            newFilters = filtersResponse.map((filters, ind) => {
                if (filters.uri === 'stars') {
                    filters.filters = filters.filters.filter(f => f.uri !== 'stars_0');
                }
                let selectedChild = filters.filters ? filters.filters.find(item => item.isSelected) : null;
                filters["isSelected"] = selectedChild ? false : true;
                if (filters.uri === "reviews") {
                    const bverygoodFilter = filters.filters.find(filter => filter.display === "reviews_bverygood");
                    const cexcellentFilter = filters.filters.find(filter => filter.display === "reviews_cexcellent");
                    if (bverygoodFilter && cexcellentFilter) {
                        bverygoodFilter.total += cexcellentFilter.total;
                    }
                    filters.filters = filters.filters.filter(item => !REVIEWS_EXCEPTIONS[item.display]);
                }
                
                return filters;
            })
        }
        return newFilters;
    }
}
